var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map",style:(("max-width: " + _vm.maxWidth + "px;"))},[_c('highcharts',{ref:"chart",attrs:{"constructorType":'mapChart',"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }